
import { formatMetricValue } from '../../lib/reportNew/formatNew'
import { metricFormat } from '../../lib/reportNew/aggregateNew'
import { makeColorAt } from './chart-themeNew'

/**
 * Ranking: alternativa tabular a un gráfico de barras.
 * Muestra el valor exacto y el peso relativo sobre el total visible.
 * Soporta multi-métrica: muestra ambas columnas de valores.
 */
export function RankingTable({ result, chartType = 'ranking' }) {
  const colorAt = makeColorAt(chartType)
  const total = result.data.reduce((acc, item) => acc + item.__total, 0) || 1
  const multiMetric = result.series.length > 1 && result.metricMap

  return (
    <ul className="flex flex-col gap-2.5">
      {result.data.map((item, index) => {
        const share = (item.__total / total) * 100
        return (
          <li key={item.__key} className="flex flex-col gap-1">
            <div className="flex items-baseline justify-between gap-3">
              <span className="flex min-w-0 items-baseline gap-2">
                <span className="w-4 shrink-0 text-right text-[12px] font-semibold text-muted-foreground">
                  {index + 1}
                </span>
                <span className="truncate text-[13px] text-foreground" title={item.name}>
                  {item.name}
                </span>
              </span>
              <span className="flex shrink-0 items-baseline gap-3">
                {multiMetric &&
                  result.series.map((seriesName) => (
                    <span
                      key={seriesName}
                      className="text-[12px] font-medium tabular-nums text-muted-foreground"
                    >
                      {formatMetricValue(item[seriesName], {
                        ...metricFormat(result.metricMap[seriesName]),
                        compact: true,
                      })}
                    </span>
                  ))}
                <span className="text-[13px] font-semibold tabular-nums text-foreground">
                  {formatMetricValue(item.__total, { ...result.format, compact: true })}
                </span>
              </span>
            </div>
            <div className="flex items-center gap-2">
              <div
                className="h-1.5 flex-1 overflow-hidden rounded-full bg-muted"
                role="presentation"
              >
                <div
                  className="h-full rounded-full"
                  style={{
                    width: `${Math.max(share, 1)}%`,
                    backgroundColor: colorAt(index),
                  }}
                />
              </div>
              <span className="w-10 shrink-0 text-right text-[12px] tabular-nums text-muted-foreground">
                {`${share.toFixed(1)}%`}
              </span>
            </div>
          </li>
        )
      })}
    </ul>
  )
}
